import request from "@/utils/request";

// 获取图形验证
export function getCaptcha() {
  return request({
    url: "/captcha",
    method: "get",
  });
}

// 用户登录接口
export function login(data) {
  return request({
    url: "/admin/login",
    method: "post",
    data,
  });
}

// 用户个人信息 /user/personInfo
export function personInfo(data) {
  return request({
    url: "/user/personInfo",
    method: "post",
    data,
  });
}

// 修改密码 /user/resetPwd
export function resetPwd(data) {
  return request({
    url: "/user/resetPwd",
    method: "post",
    data,
  });
}
// 退出登录
export function userLogout() {
  return request({
    url: "/logout",
    method: "post",
  });
}

// 获取用户的访问权限
export function getPermission() {
  return request({
    url: "/permission/admin",
    method: "post",
  });
}

//  更新用户头像
export function editAvatar(data) {
  return request({
    url: "/user/editAvatar",
    method: "post",
    params: { ...data },
  });
}
